import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { useLang } from "@/lib/i18n";
import { USECASES } from "@/lib/usecases";
import { ArrowUpRight } from "lucide-react";

/* Kompakter Block: interne Verlinkung auf die fünf Anwendungs-Landingpages. */

export default function Anwendungen() {
  const { lang } = useLang();
  return (
    <section
      id="anwendungen"
      data-testid="section-anwendungen"
      className="relative bg-[#0F1114] text-white py-24 md:py-32 border-t border-white/10"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-14">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.9 }}
          className="flex items-center gap-3 text-[11px] tracking-[0.35em] uppercase text-white/45 mb-10 font-display"
        >
          <span className="h-px w-8 bg-white/40" />
          {lang === "de" ? "Anwendungen" : "Use cases"}
        </motion.div>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-px bg-white/10 border border-white/10">
          {USECASES.map((u, i) => (
            <motion.div
              key={u.key}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.7, delay: i * 0.06 }}
              className={`bg-[#0F1114] ${i === USECASES.length - 1 ? "lg:col-span-2" : ""}`}
            >
              <Link
                to={lang === "en" ? `/en/${u.enSlug}` : `/${u.deSlug}`}
                data-testid={`anwendungen-link-${u.key}`}
                className="group flex items-start justify-between gap-4 p-6 md:p-8 h-full hover:bg-white/[0.03] transition-colors"
              >
                <span className="font-display font-light text-lg md:text-xl tracking-[-0.01em] text-white/80 group-hover:text-[#F5D77A] transition-colors leading-snug">
                  {u[lang].h1}
                </span>
                <ArrowUpRight className="h-4 w-4 mt-1.5 shrink-0 text-white/40 transition-all group-hover:text-[#F5D77A] group-hover:translate-x-0.5 group-hover:-translate-y-0.5" strokeWidth={1.5} />
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
